import React from 'react'
import { Box } from '@mui/material'
import { faMapSigns } from '@fortawesome/pro-duotone-svg-icons/faMapSigns'
import { faHome } from '@fortawesome/pro-duotone-svg-icons/faHome'
import { faChevronLeft } from '@fortawesome/pro-duotone-svg-icons/faChevronLeft'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from 'react-i18next'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'

export default class NotFound extends React.Component {
    render() {
        const environment = this.props.kedo?.env?.()?.getEnvironment?.()
        const homePath =
            this.props.error &&
            (!environment || !localStorage.getItem('environment'))
                ? '/environment'
                : '/'

        return (
            <Box
                className="mainContainer page-not-found"
                sx={{
                    display: 'flex',
                    justifyContent: this.props.error ? 'flex-start' : 'center',
                    alignItems: 'center',
                    flexDirection: 'row',
                    margin: this.props.error ? 0 : '90px auto',
                    width: this.props.error ? 'auto' : '70%',
                }}
            >
                <Box sx={{ marginRight: '50px' }}>
                    <FontAwesomeIcon
                        className="background-icon"
                        icon={faMapSigns}
                    />
                </Box>
                <Box>
                    <h1>
                        {this.props.error ? (
                            this.props.error && this.props.error.toString()
                        ) : (
                            <span>
                                <Trans i18nKey="Something went wrong">
                                    Something went wrong
                                </Trans>
                                ...
                            </span>
                        )}
                    </h1>
                    <p>
                        <Trans i18nKey="404_general_message">
                            The page may not exist or you may not have the
                            necessary rights. If you think this is incorrect,
                            please contact your system administrator.
                        </Trans>
                    </p>

                    <div>
                        <span>
                            <StyledButton
                                onClick={() => {
                                    if (window.history.length > 1) {
                                        if (this.props.error) {
                                            window.addEventListener(
                                                'popstate',
                                                () => window.location.reload(),
                                                { once: true }
                                            )
                                        }
                                        window.history.back()
                                    } else {
                                        window.location.href = homePath
                                    }
                                }}
                                sx={{ marginTop: '-0.5px' }}
                            >
                                <FontAwesomeIcon icon={faChevronLeft} />
                                &nbsp; <Trans i18nKey="Back to">
                                    Back to
                                </Trans>{' '}
                                <Trans i18nKey="previous page">
                                    previous page
                                </Trans>
                            </StyledButton>
                            &nbsp; &nbsp;
                        </span>
                        <StyledButton
                            onClick={() => {
                                window.location.href = homePath
                            }}
                            color={'secondary'}
                        >
                            <FontAwesomeIcon icon={faHome} />
                            &nbsp; <Trans i18nKey="Back to">Back to</Trans>{' '}
                            <Trans i18nKey="Homepage">Homepage</Trans>
                        </StyledButton>{' '}
                        &nbsp;
                    </div>
                </Box>
            </Box>
        )
    }
}
